import batchService from "services/batchService";
import { generateBatchExternalCode } from "utils/generateBatchExternalCode";

export const checkBatch = async ({ batchId, productBaseId }) => {
  try {
    const { data: batchData } = await batchService.getBatchDetail(batchId);
    const batchProductBaseId = batchData.product?.id;
    const batchReceiptDate = batchData.receipt_date;

    if (!batchReceiptDate) {
      throw new Error(`O lote ${batchId} ainda não foi recebido`);
    }

    const isInvalidProductBase = productBaseId !== batchProductBaseId;

    if (isInvalidProductBase) {
      throw new Error("O produto base do lote é diferente do sku selecionado", {
        status: 400
      });
    }

    // Vencimento calculado pelo backend (receipt_date + shelf life da
    // classificacao). Nao usar product.shelf_life no front.
    const dateNow = new Date();
    const rawShelfLifeDate = batchData.shelf_life_date;
    const shelfLifeDate = rawShelfLifeDate ? new Date(rawShelfLifeDate) : null;
    const hasValidShelfLifeDate =
      shelfLifeDate instanceof Date && !Number.isNaN(shelfLifeDate.getTime());

    const batchExternalCode = generateBatchExternalCode(batchData);
    // Com data valida, compara normalmente. Se o backend mandou uma data
    // invalida, nao pode passar como "nao vencido": por seguranca tratamos
    // como vencido para forcar a confirmacao. Sem data (null) mantem o
    // comportamento de nao bloquear.
    const isProductExpired = hasValidShelfLifeDate
      ? dateNow >= shelfLifeDate
      : Boolean(rawShelfLifeDate);
    const classification = batchData.classification;
    return { batchExternalCode, isProductExpired, classification };
  } catch (error) {
    const notFound = error.response?.status === 404;
    const errorMessage = notFound
      ? `Lote ${batchId} não encontrado`
      : error.message;
    throw new Error(errorMessage);
  }
};
